import { render, staticRenderFns } from "./CreateQuestionnaire.vue?vue&type=template&id=6a8c2b60&"
import script from "./CreateQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./CreateQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuestionnaire.vue?vue&type=style&index=0&id=6a8c2b60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports